import { render, staticRenderFns } from "./VmDialogCard.vue?vue&type=template&id=773e25ca&scoped=true&"
import script from "./VmDialogCard.vue?vue&type=script&lang=js&"
export * from "./VmDialogCard.vue?vue&type=script&lang=js&"
import style0 from "./VmDialogCard.vue?vue&type=style&index=0&id=773e25ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773e25ca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCardTitle,VRow})
